export default __webpack_public_path__ + "static/media/621.586f11f2.png";